import React, { useEffect } from "react";
import Routers from "./Route";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";

const App = () => {
  useEffect(() => {
    const handleWheel = () => {
      const activeElement = document.activeElement;

      if (
        activeElement instanceof HTMLInputElement &&
        activeElement.type === "number"
      ) {
        activeElement.blur();
      }
    };

    document.addEventListener("wheel", handleWheel, {
      passive: true,
    });

    return () => {
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <div className="App">
      <CustomizerProvider>
        <AnimationThemeProvider>
          <Routers />
        </AnimationThemeProvider>
      </CustomizerProvider>
    </div>
  );
};

export default App;